<template>
    <svg v-if="uiStore.tenant && uiStore.tenant.id == 2" xmlns="http://www.w3.org/2000/svg" version="1.1" viewBox="0 0 53.3 53.3" xml:space="preserve" width="100%" height="100%">
        <circle style="fill:none;stroke:currentColor;stroke-miterlimit:10;" cx="26.7" cy="26.7" r="26.2"/>
        <path fill="currentColor" d="M24.7,36.5c-3,4-1.8,6.2-5.8,8.8-2.3,1.5-7,.9-7.9-2s.4-6.1-.1-8.6c-1-4.7-3.4-6-4.7-6.1s4.4-3.2,6,1.1c1.6,4.3,1.9,7.6,4.4,7,2.4-.5,4.6-2.9,5.8-6.7s-1.3-8-.1-12c.6-2.1,2-3.9,3.9-4.9,0,0-1.8,4.1-1.1,7.3s1.2,5,2.3,5.2,3.5-1.9,5.5-7.1c1.7-4.4,1.7-9.2,0-13.6,0,0,2.6-.5,3.8,4.2,1.3,5.6.6,11.4-2,16.5,0,0,5.5-.5,7.9-4,1.5-2.4,2.6-5.1,3.1-7.9,1.7,2.9,1.9,6.4.6,9.5-2.3,5.1-12.5,7-16.7,9.3s-4.9,3.9-4.9,3.9Z"/>
    </svg>
    <svg v-else version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 485.7 485.7" xml:space="preserve" width="100%" height="100%">
        <path style="fill:none;stroke:currentColor;stroke-width:15;stroke-miterlimit:10;" d="M20.4,319.3c17.9,22.9,87.7,27.5,129.1-34.7s59.8-124.2,53.9-169.6s-40.9-36.6-44.8,34.5
        s112.6,161.5,112.6,211.9s-62.8,48.8-62.8,2.4S350.7,233.8,361,145.2c8.3-71.5-51.1-73.2-49.1,17.7s26.4,143.9,71.8,165.4
        c38,18,71.7,3.4,82.6-11.5"/>
        <path style="fill:none;stroke:currentColor;stroke-width:15;stroke-miterlimit:10;" d="M478.2,242.8c0,130-105.4,235.3-235.3,235.3S7.5,372.8,7.5,242.8S112.9,7.5,242.8,7.5
        S478.2,112.9,478.2,242.8z"/>
    </svg>
</template>
<script type="text/javascript">
    import { UseUIStore } from '@/store/UI.js';

    export default {

        setup() {
            return {
                uiStore: UseUIStore(),
            };
        },
        
    };

</script>